// extracted by mini-css-extract-plugin
export default {"quizCard":"quizPage_quizCard__TcJ-7","coloredInput":"quizPage_coloredInput__BuSIA","correctAnsw":"quizPage_correctAnsw__w3dle"};